import { motion } from "framer-motion";
import styles from "./css/Question.module.css";
import { pageVariants, pageTransition, btnHover, btnTap } from "../utils/animations";

const Question03 = ({ setHandleEvent, setAvance }) => {

	const handleEvent = (value) => {
		setAvance(8);
		setHandleEvent(prevState => ({ ...prevState, value03: value }));
	};

	return (
		<motion.div
			className={styles.containerQuestion}
			variants={pageVariants}
			initial="initial"
			animate="animate"
			exit="exit"
			transition={pageTransition}
		>
			<div className={styles.titleQuestion}>
				¿Se suscitó algún inconveniente al momento de comunicarse con nosotros?
			</div>
			<div className={styles.containerOptions}>
				<motion.div className={styles.controlButton} onClick={() => handleEvent(1)} whileHover={btnHover} whileTap={btnTap}>
					Sí
				</motion.div>
				<motion.div className={styles.controlButton} onClick={() => handleEvent(0)} whileHover={btnHover} whileTap={btnTap}>
					No
				</motion.div>
			</div>
		</motion.div>
	);
};

export default Question03;
